import { render, staticRenderFns } from "./MfMasonry.vue?vue&type=template&id=6024a280&scoped=true&"
import script from "./MfMasonry.vue?vue&type=script&lang=js&"
export * from "./MfMasonry.vue?vue&type=script&lang=js&"
import style0 from "./MfMasonry.vue?vue&type=style&index=0&id=6024a280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024a280",
  null
  
)

export default component.exports